export default function FilterBar() {
  return (
    <div className="bg-white p-4 rounded-xl shadow flex gap-4">
      <select className="border rounded px-3 py-2 text-sm">
        <option>ทุกสาขา</option>
        <option>สาขา A</option>
        <option>สาขา B</option>
      </select>

      <select className="border rounded px-3 py-2 text-sm">
        <option>วันนี้</option>
        <option>สัปดาห์นี้</option>
        <option>เดือนนี้</option>
      </select>
    </div>
  );
}
